export class NotificationHandlerHelper {

    public static init() : void {
        window.toastr.options.preventDuplicates = true;

        const notification = $('.notification');

        if (notification.length === 0) {
            return;
        }

        const title = notification.data('title');
        const content = notification.data('content');

        if (typeof title === 'undefined') {
            throw 'title is missing';
        }
        if (typeof content === 'undefined') {
            throw 'content is missing';
        }

        if (notification.hasClass('success')) {
            window.toastr.success(content, title);
        }
        else if (notification.hasClass('warning')) {
            window.toastr.warning(content, title);
        }
        else if (notification.hasClass('error')) {
            window.toastr.error(content, title);
        }
    }

}
